import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.71558 6.30449C5.03474 5.93623 5.59199 5.89643 5.96024 6.21558L19.1955 17.6861C19.5638 18.0053 19.6036 18.5626 19.2844 18.9308C18.9653 19.2991 18.408 19.3389 18.0398 19.0197L4.80449 7.54915C4.43623 7.22999 4.39643 6.67274 4.71558 6.30449Z'
            />
            <path d='M15.36 14.4632C15.36 16.4165 13.8557 18 12 18C10.1443 18 8.64001 16.4165 8.64001 14.4632C8.64001 12.5098 10.1443 10.9263 12 10.9263C13.8557 10.9263 15.36 12.5098 15.36 14.4632Z' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.84 16.3578C4.30392 16.3578 4.68 15.9619 4.68 15.4736C4.68 13.43 5.45121 11.4701 6.82398 10.0251C8.19675 8.58012 10.0586 7.76831 12 7.76831C13.9414 7.76831 15.8033 8.58012 17.176 10.0251C18.5488 11.4702 19.32 13.43 19.32 15.4736C19.32 15.9619 19.6961 16.3578 20.16 16.3578C20.6239 16.3578 21 15.9619 21 15.4736C21 12.961 20.0518 10.5513 18.364 8.77467C16.6761 6.99801 14.3869 5.99989 12 5.99989C9.61305 5.99989 7.32387 6.99801 5.63604 8.77467C3.94821 10.5513 3 12.961 3 15.4736C3 15.9619 3.37608 16.3578 3.84 16.3578Z'
            />
        </SvgIcon>
    );
});
